import axios from 'axios';

const apiClient = axios.create({
  baseURL: import.meta.env.VITE_API_URL || 'http://localhost:3000/api',
  headers: {
    'Content-Type': 'application/json'
  }
});

// Request interceptor to add auth token
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle errors
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const errorCode = error.response?.data?.code;

    // Trial abgelaufen -> zur Abonnement-Seite weiterleiten
    if (status === 403 && errorCode === 'TRIAL_EXPIRED') {
      const isAbonnementPage = window.location.pathname.includes('/abonnement');
      if (!isAbonnementPage) {
        window.location.replace('/einstellungen/abonnement');
      }
      return Promise.reject(error);
    }

    // 401 = kein Token, 403 mit "Invalid or expired token" = ungültiges Token
    const isAuthError = status === 401 ||
      (status === 403 && error.response?.data?.error?.includes('token'));

    if (isAuthError) {
      const token = localStorage.getItem('token');
      const isLoginPage = window.location.pathname.includes('/login');

      // Vermeide Redirect-Loop und unnötiges Ausloggen
      if (token && !isLoginPage) {
        localStorage.removeItem('token');
        // Sanfte Navigation ohne kompletten Reload
        window.location.replace('/login');
      }
    }
    return Promise.reject(error);
  }
);

export default apiClient;
